<app-breadcrumb [master]="'Administracja'" [parentName]="'Szablony'" [name]="'Lista'"></app-breadcrumb>
<div class="template-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="template-list-filters">
    <mat-form-field class="template-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Plik.docx" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'template_type'"
      [label]="'Typ'" class="template-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

    <app-datepicker
      class="template-list-filter"
      label="Data dodania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="template-list-filter"
      label="Data dodania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <mat-form-field class="template-list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'contract_type'"
      [label]="'Typ umowy'" class="template-list-filter"
      [(ngModel)]="initialFilters.contractType" name="contractType"
    ></app-dict>

    <app-dict
      [multiple]="false" [dictType]="'company'"
      [label]="'Firma'" class="template-list-filter"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-insurance-companies
      class="template-list-filter" [multiple]="true"
      label="TU" [required]="false"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
    ></app-dict-insurance-companies>

    <app-datepicker
      class="template-list-filter"
      label="Data obowiązywania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$validFrom" name="gte$validFrom"
    ></app-datepicker>

    <app-datepicker
      class="template-list-filter"
      label="Data obowiązywania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$validFrom" name="lte$validFrom"
    ></app-datepicker>

  </form>

  <div class="template-list-buttons">
    <button *ngIf="(userPermissions | async).template.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).template.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="templates">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button color="accent" aria-label="" (click)="downloadFile(element.uuid)">
          <mat-icon>download</mat-icon>
        </button>
        <a *ngIf=controlTest() class="default-link" [routerLink]="['/dokumenty/rejestracje/szablony/szczegoly', element.uuid]">{{element.name}}</a>
        <a *ngIf=!controlTest()  class="default-link" [routerLink]="['/dokumenty/szablony/szczegoly', element.uuid]">{{element.name}}</a>

      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Typ </th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.user?.username}}
      </td>
    </ng-container>

    <ng-container matColumnDef="contractType">
      <th mat-header-cell *matHeaderCellDef> Typ umowy </th>
      <td mat-cell *matCellDef="let element">
          {{element.contractType?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
        <ng-container *ngFor="let company of element.companies">
          {{company.name}}<br>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="formOfBusiness">
      <th mat-header-cell *matHeaderCellDef> Typ działalności </th>
      <td mat-cell *matCellDef="let element">
        {{element.formOfBusiness?.name}}
      </td>
    </ng-container>

      <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button [disabled]="!(userPermissions | async).template.delete" mat-icon-button color="warn" aria-label="" (click)="deleteFile(element.uuid)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
